module.exports = __webpack_public_path__ + "img/rachmaninoff-dances.70ca7153.jpg";